/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-progress-bar[_ngcontent-%COMP%]{position:fixed;top:0;z-index:100}"];
export { styles as styles };
